import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined'
import {Image} from 'antd'
import classNames from 'classnames'
import copyToClipboard from 'copy-to-clipboard'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useLayoutEffect, useMemo, useState} from 'react'
import {BsDiamondFill, BsTagsFill} from 'react-icons/bs'
import {GiIronCross} from 'react-icons/gi'
import {Link} from 'react-router-dom'
import Ahref from "../Ahref";
import {paths} from 'views/MainPage/contains'
import {ImagePlaceholder} from '../../conts/imageBase64'
import getLinkToDetail from '../../helpers/getLinkToDetail'
import {renderIf, renderIfElse, validateUrl} from '../../views/Shared'
import ImageLoader from '../ImageLoader'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import Description, {mapKeywords} from './Description'
import FeedContext from './FeedContext'
import Mark from "mark.js";
import {VideoEmbed} from "./VideoEmbed";
import {GoDotFill} from "react-icons/go";
import {HiViewfinderCircle} from "react-icons/hi2";
import {FaHashtag} from "react-icons/fa6";
import Pure from "../Pure";
import {ifThenElseMultipleConditions} from "../../helpers/ifThenElseMultipleConditions";
import {formatRelativeTime} from "../../helpers/dateUtils";
import getTitle from "../../helpers/getTitle";

export function LinkfyEmbed({
                                title,
                                url,
                                subTitle,
                                description,
                                categories = [],
                                image,
                                style = {},
                                className = '',
                                selectable = false,
                            }) {
    const Wrapper = useMemo(
        () =>
            ({children}) => {
                if (selectable) {
                    return children
                } else {
                    return (
                        <Ahref
                            href={url}
                            target="_blank"
                            style={{boxShadow: 'none'}}
                            onClick={(event) => {
                                event.stopPropagation()
                            }}>
                            {children}
                        </Ahref>
                    )
                }
            },
        [selectable]
    )

    return (
        <Wrapper>
            <div
                style={{
                    borderRadius: '0.3em',
                    ...style,
                }}
                className={classNames('cursor-pointer', className)}>
                <div className="w-full flex gap-3 overflow-hidden">
                    <div className="flex flex-1 flex-col gap-2">
                        {subTitle && (
                            <div className="flex items-center gap-2">
                                <img
                                    style={{
                                        verticalAlign: 'sub',
                                        margin: 0,
                                    }}
                                    alt={title}
                                    src={`https://www.google.com/s2/favicons?domain=${subTitle}`}
                                />
                                <span
                                    className="truncate flex-1 text-sm text-color-300 hover:underline leading-tight italic">
                  {subTitle}
                </span>
                            </div>
                        )}
                        <div className="font-bold text-lg text-primary leading-tight">
                            {title}
                        </div>
                        <div className="text-sm text-color-400 italic leading-snug">
                            {description}
                        </div>
                        {categories.length > 0 && (
                            <div className="text-xs text-color-200 leading-none">
                                {categories.map((e) => (
                                    <Link
                                        key={e.id}
                                        className="leading-none"
                                        to={
                                            paths.categoryPath
                                                .replace(':category', e.id)
                                        }>
                                        {' '}
                                        • {e.name}
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                    {!!image && (
                        <ImageLoader
                            style={{
                                width: '15%',
                                height: '15%',
                                objectFit: 'cover',
                                marginTop: 0,
                                marginBottom: 0,
                            }}
                            src={image}
                        />
                    )}
                </div>
            </div>
        </Wrapper>
    )
}

/**
 * @return {null}
 */
export function BaseEmbed({
                              url,
                              title,
                              description,
                              keywords = [],
                              categories = [],
                              image,
                          }) {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {url: feed_url, handleClick} = useContext(FeedContext)

    const linkToUrl = feed_url || url;

    if (title) {
        return (
            <div className="flex flex-col gap-3 BaseEmbed">
                <div className="flex flex-col gap-1">
                    <Link to={linkToUrl}
                          className="font-bold text-base text-color-000 no-underline tracking-wide leading-snug">
                        {title}
                    </Link>
                    {description && (
                        <Pure input={[description]}>
                            <div className="flex-1 max-lines-3 text-sm text-color-300">
                                {mapKeywords(description, keywords || [])}
                            </div>
                        </Pure>
                    )}
                </div>
                {!!image && (
                    <Pure input={[image]}>
                        <Image
                            wrapperClassName="w-full 99-99-99"
                            className="object-cover"
                            preview={false}
                            src={image}
                            fallback={ImagePlaceholder}
                            style={{objectPosition: "center"}}
                        />
                    </Pure>
                )}
                {
                    categories.length > 0 && (
                        <Pure input={[categories.length]}>
                            <div className="mx-3 flex flex-wrap items-center gap-2">
                                {categories.slice(0, isSm ? 3 : 5).map((e) => (
                                    <div
                                        key={e.id}
                                        className="flex items-center gap-2 text-primary">
                                        <GiIronCross size={7}/>
                                        <Link
                                            className="font-medium text-xs italic"
                                            to={
                                                paths.categoryPath
                                                    .replace(':category', e.id)
                                            }>
                                            {e.name}
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </Pure>
                    )}
            </div>
        )
    } else {
        return null
    }
}

export function DetailEmbed({
                                id,
                                title,
                                url,
                                video_url,
                                subTitle,
                                description,
                                categories = [],
                                photo,
                                content,
                                keywords = [],
                                others = [],
                            }) {
    const t = useTranslate()
    const {item, ...rest} = useContext(FeedContext)
    const [toggleLinkView, setToggleLinkView] = useState(false)

    const _renderContentItem = (it, i) => {
        switch (_.get(it, 'type', 'p')) {
            case 'img':
                return !_.has(it, 'url') ? null : (
                    <div
                        className="py-4 w-full"
                        key={i}>
                        <Image
                            wrapperClassName="w-full"
                            className="object-cover bg-no-repeat rounded-md "
                            src={_.get(it, 'url')}
                            alt={_.get(it, 'alt', '')}
                            preview={{
                                mask: (
                                    <div className="w-full h-full relative">
                                        <HiViewfinderCircle
                                            size={16}
                                            style={{top: 10, right: 10}}
                                            className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                        />
                                    </div>
                                ),
                            }}
                        />
                        {_.has(it, 'value') && (
                            <Description
                                compact
                                Wrapper="figcaption"
                                className="text-color-300 text-sm italic text-center leading-snug mt-1">
                                {_.get(it, 'value')}
                            </Description>
                        )}
                    </div>
                )
            case 'html':
                return !_.has(it, 'value') ? null : (
                    <div
                        className="py-2 w-full flex"
                        key={i}>
                        <div
                            className="flex-1 fix-table w-0 overflow-auto"
                            dangerouslySetInnerHTML={{
                                __html: _.get(it, 'value'),
                            }}
                            key={i}
                        />
                    </div>
                )
            case 'h':
                const _level = ifThenElseMultipleConditions(
                    "h3",
                    _.get(it, 'header_level', 3) === 2, "h2",
                    _.get(it, 'header_level', 3) === 4, "h4",
                    _.get(it, 'header_level', 3) === 5, "h5"
                )
                return !_.has(it, 'value') ? null : (
                    <Description
                        Wrapper={_level}
                        className="py-2 font-semibold"
                        ghostbav
                        key={i}>
                        {_.get(it, 'value', '')}
                    </Description>
                )
            case 'video':
                return (
                    <VideoEmbed
                        key={i}
                        className="mt-3"
                        title={title}
                        url={it?.url}
                        subTitle={subTitle}
                        description={description}
                        isShowPlayer={true}
                    />
                )
            default:
                return !_.has(it, 'value') ? null : (
                    <Description
                        className="py-2"
                        ghostbav
                        key={i}>
                        {_.get(it, 'value', '')}
                    </Description>
                )
        }
    }


    const contentId = id + '-content';

    useLayoutEffect(() => {
        const mark_content = document.getElementById(contentId)
        if (!mark_content) return

        const markInstance = new Mark(mark_content)

        const markedKeywords = new Set()

        markInstance.mark(
            keywords.map((e) => e?.keyword),
            {
                element: 'a',
                diacritics: false,
                accuracy: 'exactly',
                separateWordSearch: false,
                className: 'text-content-mark',
                each: (element) => {
                    const text = element.textContent?.toLowerCase()
                    if (!text) return

                    // đã mark keyword này rồi → bỏ
                    if (markedKeywords.has(text)) {
                        // bỏ thẻ <a>, giữ lại text
                        const parent = element.parentNode
                        parent.replaceChild(
                            document.createTextNode(element.textContent),
                            element
                        )
                        return
                    }

                    markedKeywords.add(text)

                    const current = _.find(
                        keywords,
                        (e) =>
                            String(e?.keyword ?? '').toLowerCase() === text
                    )

                    element.setAttribute(
                        'href',
                        current ? getLinkToDetail(current) : '#'
                    )
                },
            }
        )

        return () => {
            if (markInstance) markInstance.unmark()
        }
    }, [])

    return (
        <React.Fragment>
            <div className="mt-3 DetailEmbed">
                {/* Image Banner */}
                {renderIfElse(
                    photo && !video_url,
                    <Image
                        preview={false}
                        wrapperClassName="w-full"
                        className="w-full object-cover bg-no-repeat rounded-2xl"
                        src={photo}
                        alt={photo}
                    />
                )}
                {/* Video Banner */}
                {renderIf(
                    video_url,
                    <VideoEmbed
                        title={title}
                        url={video_url}
                        subTitle={subTitle}
                        isShowPlayer={true}
                    />
                )}

                <div className="my-3 px-3 lg:px-0 flex overflow-hidden">
                    <div className="break-words flex flex-col gap-3 flex-1 1111-2222">
                        <span className="font-semibold text-xs text-secondary-600 tracking-wider">
                            {getTitle(item?.container).toUpperCase()}
                            <span className="ml-1 font-normal text-color-400">
                                {` \u2022  ${formatRelativeTime(item?.created)}`}
                            </span>
                        </span>
                        <h1>
                            <Link
                                to={getLinkToDetail(item)}
                                className="font-bold text-gray-900 text-lg md:text-2xl leading-snug no-underline">
                                {title}
                            </Link>
                        </h1>
                        {renderIf(
                            description,
                            <div className="pl-2 p-2 border-l-2 border-slate-300 text-slate-400 bg-slate-50 rounded-r-xl italic leading-relaxed">
                                {description}
                            </div>
                        )}
                        {renderIf(
                            categories.length > 0,
                            <div className="flex gap-3 text-xs italic">
                                {categories.map((e) => (
                                    <div
                                        key={e.id}
                                        className="flex items-center text-slate-500 hover:text-primary">
                                        <BsDiamondFill size={5} className="mr-1"/>
                                        <Link
                                            className="italic font-medium text-xs"
                                            to={paths.categoryPath.replace(':category', e.id)}>
                                            {e.name}
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                {renderIf(
                    !_.isEmpty(content),
                    <div id={contentId}
                         className="mt-2 whitespace-pre-wrap p-3 background rounded-lg leading-7 w-full text-lg-em">
                        {content.map((it, i) => {
                            return _renderContentItem(it, i)
                        })}
                    </div>
                )}
                {renderIf(
                    others.length > 0,
                    <div className="mt-6 ml-2 flex flex-col gap-1">
                        <span className="font-semibold text-color-100 tracking-wider">
                            {`${t('see more posts from this channel')}: `}
                        </span>
                        <div className="ml-1 flex flex-col gap-2">
                            {others.slice(0, 3).map((e, i) => (
                                <Link
                                    key={i}
                                    to={{pathname: `/news/${e._type}/${e.id}`}}
                                    className="space-x-2 text-color-300 leading-snug italic no-underline">
                                    <GoDotFill size={10}/>
                                    <span className="text-sm flex-1">
                                        {_.truncate(_.get(e, 'overview.title'), {length: 160})}
                                    </span>
                                </Link>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {renderIf(
                subTitle,
                <div className="flex my-3">
                    <div className="flex-1"/>
                    <div className="flex flex-center mx-2 px-2 py-1 background-200 rounded-full">
                        <div className="px-2 text-sm text-color-300 italic">
                            {`${t('source')} :`}
                        </div>
                        <div className="font-semibold text-sm text-color-100 pr-1">{subTitle}</div>
                        {!toggleLinkView && (
                            <QuestionCircleOutlined
                                size={14}
                                onClick={() => {
                                    copyToClipboard(url)
                                    setToggleLinkView(true)
                                }}
                                className="px-2 text-sm text-color-400 hover:text-color-100 italic cursor-pointer"
                            />
                        )}
                    </div>
                </div>
            )}

            {toggleLinkView && (
                <div className="whitespace-normal space-x-1 my-3 text-xs italic">
                    <span className="text-color-500">
                        {`${t('source')} : `}
                    </span>
                    {validateUrl(url) ? (
                        <Ahref href={url} target="_blank" className="text-primary-600 font-medium no-underline">
                            {url}
                        </Ahref>) : (
                        <span className="text-primary font-medium">{url}</span>
                    )}
                </div>
            )}
        </React.Fragment>
    )
}

export const Keywords = (props) => {
    const t = useTranslate()
    const keywords = Array.from(props.keywords ?? [])
    return keywords?.length > 0 && (
        <div id="keywords" className="flex flex-wrap gap-2">
            <span className="flex items-center gap-1">
                <BsTagsFill size={14} className="text-slate-300"/>
                <span className="font-semibold text-slate-500 uppercase">
                    {`${t('keywords')}: `}
                </span>
            </span>
            {keywords.map(({keyword, idname}, index) => (
                <Link
                    key={index}
                    to={`/t/${idname}/news`}
                    style={{padding: '3px 12px', borderRadius: 999}}
                    className="bg-slate-50 hover:bg-primary-50 font-medium text-xs text-slate-500 no-underline">
                    {keyword}
                </Link>
            ))}
        </div>
    )
}
